(function () {
  /* Load table data via section rendering API */
  var body = document.getElementById('fitment-table-body');
  if (!body) return;

  var wrapper = body.closest('[data-section-render]');
  if (!wrapper) return;

  var renderSectionId = wrapper.getAttribute('data-section-render');
  var productUrl = wrapper.getAttribute('data-product-url');
  if (!renderSectionId || !productUrl) return;

  function fetchSection(variantId) {
    var url = productUrl + '?section_id=' + renderSectionId;
    if (variantId) url += '&variant=' + variantId;

    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = new DOMParser().parseFromString(html, 'text/html');
        var content = tmp.getElementById('fitment-table-content');
        if (content) body.innerHTML = content.innerHTML;
      });
  }

  fetchSection();

  document.addEventListener('variant:changed', function (e) {
    var id = e.detail && e.detail.variant && e.detail.variant.id;
    fetchSection(id);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('#fitment-table-body')) fetchSection();
  });
})();
